var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterOPlatformi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-3,.cls-4{stroke:#fa7268;}.cls-1,.cls-3,.cls-4,.cls-8{stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{fill:#159497;}.cls-3,.cls-8{fill:#fff;}.cls-4,.cls-5{fill:#6e5dd8;}.cls-6{fill:#aa6276;}.cls-7{fill:#fa7268;}.cls-8{stroke:#159497;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.05,292.64c5.55-22.71,16.37-40.58,29-47.91s26.89-4,38.2,9c5.33,6.1,10,14.12,14.9,21.3s10.38,13.67,16.5,15.95,13-.35,17.21-9.1c5-10.4,4.9-26,4.61-40s-.22-29.69,4.92-39.8c4.15-8.18,10.76-10.45,16.67-8.61s11.33,7.22,16.63,12.52l21.58,21.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M561.78,24.37H377.32A13.28,13.28,0,0,0,364,37.64V49.38h211V37.64A13.27,13.27,0,0,0,561.78,24.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.04,
    y: 24.37,
    width: 211.01,
    height: 143.44,
    rx: 13.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 364.04,
    y1: 49.38,
    x2: 575.05,
    y2: 49.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 378.92,
    cy: 37.53,
    r: 5.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 397.19,
    cy: 37.53,
    r: 5.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 415.46,
    cy: 37.53,
    r: 5.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 504.85,
    cy: 250.53,
    r: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 57.32,
    y: 279.4,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "536.25 175.55 545.19 160.06 527.31 160.06 536.25 175.55"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 300,
    cy: 162.5,
    r: 122.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M312.12,216.47h13.4q6.74,0,9.56,2.44T337.9,227c0,3.83-1,6.6-2.87,8.29s-5.09,2.53-9.51,2.53h-52q-6.63,0-9.51-2.53c-1.92-1.69-2.87-4.46-2.87-8.29s.92-6.47,2.77-8.09,5.06-2.44,9.61-2.44h14.66V169.09h-11q-6.53,0-9.36-2.49c-1.88-1.66-2.83-4.4-2.83-8.24s.91-6.56,2.74-8.19,5-2.43,9.45-2.43h29.35a6.76,6.76,0,0,1,4.19,1.12,3.67,3.67,0,0,1,1.46,3.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 296.33,
    cy: 107.12,
    r: 22.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.53,271.31c-22-15.76-38.21-19.92-51.58-29.26-4.49-3.14-8.8-6.83-11.36-11.67s-3.12-11.06-.22-15.71c4.65-7.46,15.16-7.86,23.94-7.4l-31.2-20.8c-8.49-5.66-18-13.1-17.68-23.29.26-9.74,11.78-17.3,20.82-13.67a83,83,0,0,1-42.08-38.66c-3.91-7.66-6.64-16.4-4.86-24.82,3-14.35,19.22-23.34,33.77-21.49S90,76.86,97.64,89.35s11.47,26.93,15.16,41.12c-1.48-6.79,4.78-13.63,11.71-14.25s13.58,3.78,17.39,9.6,5.23,12.86,6,19.77a136.09,136.09,0,0,1-4.33,53.15c4.26-5,12.77-4.38,17.54.09s6.21,11.6,5.45,18.09-3.43,12.58-5.82,18.66c-6,15.33-17.25,35.73-17.25,35.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.5,117.51a74.36,74.36,0,0,1,6.53-52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.58,58.31a23.35,23.35,0,0,0,42.61-4.76c1.07-3.49,1.19-7.61-1.11-10.44s-7.57-3.1-9.2.17a7.53,7.53,0,0,0,0-10.11c-2.68-2.75-7-2.58-10-.54-2.34-9.17-14.87-11-20.56-4C128.35,35.93,128.17,50.6,132.58,58.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.64,293c-12.17-19.72-19.25-42.11-25.33-64.47S118,183.44,109.05,162.06s-22-41.67-40.73-55.25"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 478.68,
    y: 63.59,
    width: 71.33,
    height: 82.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterOPlatformi);
export default __webpack_public_path__ + "static/media/Footer-o_platformi.07ebcd412a15231f9399075811e0374b.svg";
export { ForwardRef as ReactComponent };